import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { RTOProvider } from "./Context/RTOContext";
import AppTheme from "./Shared-Theme/AppTheme";

import CssBaseline from "@mui/material/CssBaseline";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <RTOProvider>
      <AppTheme>
        <CssBaseline enableColorScheme />
        <App />
      </AppTheme>
    </RTOProvider>
  </React.StrictMode>
);

reportWebVitals();